// Estados del lead. Sprint CRM 2026-05-17 colapsó 7 → 6 (migration 0058).
// Flujo: prospecto → cotizado → negociando → por_firmar → ganado/perdido.
export const LEAD_STATES = [
  'prospecto',
  'cotizado',
  'negociando',
  'por_firmar',
  'ganado',
  'perdido',
] as const;

export type LeadState = (typeof LEAD_STATES)[number];

export const LEAD_STATE_LABELS: Record<LeadState, string> = {
  prospecto: 'Prospecto',
  cotizado: 'Cotizado',
  negociando: 'Negociando',
  por_firmar: 'Por firmar',
  ganado: 'Ganado',
  perdido: 'Perdido',
};

// Colores semánticos del design system. Se aplican como CSS variables
// (var(--color-warning), etc.) en pills, dots, borders.
export const LEAD_STATE_COLORS: Record<LeadState, string> = {
  prospecto: 'var(--color-fg-subtle)',
  cotizado: 'var(--color-warning)',
  negociando: 'var(--color-info)',
  por_firmar: 'var(--color-purple)',
  ganado: 'var(--color-success)',
  perdido: 'var(--color-danger)',
};
